import {message, Space} from "antd";
import {useFormContext} from "react-hook-form";
import {EditStoreServiceBasicFormStepFormValues} from "../schema-validation";
import {FormFieldError} from "../../../../design-system/form-field";
import {useGetStoreServiceContext} from "../context/get-store-service";
import {
  useGetStoreServicePortfolioImages,
  useStoreServicePortfolioImagesDelete,
  useStoreServiceUploadPortfolioImages,
} from "../../../../react-query-hooks/store/services/upload-content";
import {ServicePortfolioImagesFormFields} from "../../../../components/offering-form/services/portfolio-images";

export function EditStoreServicePortfolioImagesUpload() {
  const {
    state: {storeServiceData},
  } = useGetStoreServiceContext();
  const {setValue, watch, formState} =
    useFormContext<EditStoreServiceBasicFormStepFormValues>();
  const storeServicePortfolioImagesDeleteMutation =
    useStoreServicePortfolioImagesDelete();
  const storeServiceUploadPortfolioImagesMutation =
    useStoreServiceUploadPortfolioImages();
  const getStoreServicePortfolioImages = useGetStoreServicePortfolioImages(
    storeServiceData.productService.id
  );

  function handlePortfolioImagesItemDelete({
    mediaId,
    productServiceId,
  }: {
    mediaId: string;
    productServiceId: number;
  }) {
    storeServicePortfolioImagesDeleteMutation.mutate(
      {mediaId, storeServiceId: productServiceId},
      {
        onSuccess: () => {
          const currentPortfolioImages = watch("portfolio_images");

          const newValues = currentPortfolioImages.filter((x) => x.id !== mediaId);
          console.log({currentPortfolioImages, newValues});
          setValue("portfolio_images", newValues);
          message.success("Deleted successfully");
        },
      }
    );
  }
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        {getStoreServicePortfolioImages.isLoading ? (
          <>Loading....</>
        ) : getStoreServicePortfolioImages.isError ? (
          <>{getStoreServicePortfolioImages.error.message}</>
        ) : (
          <>
            <ServicePortfolioImagesFormFields
              accordionIndex={0}
              serviceData={{
                id: storeServiceData.productService.id.toString(),
              }}
              defaultPortfolioImages={getStoreServicePortfolioImages.data}
              deletePortfolioImage={handlePortfolioImagesItemDelete}
              isDeleteLoading={storeServicePortfolioImagesDeleteMutation.isLoading}
              productServiceId={storeServiceData.productService.id}
              isUploadLoading={getStoreServicePortfolioImages.isLoading}
              uploadPortfolioImages={storeServiceUploadPortfolioImagesMutation}
            />
            <FormFieldError errorMessage={formState.errors.cover_images?.message} />
          </>
        )}
      </Space>
    </div>
  );
}
